<template>
  <div>
    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldName')}:`"
      label-for="input-instructional-moment-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-instructional-moment-name"
        name="input-instructional-moment-name"
        v-model="$v.instructional_moment.name.$model"
        :state="validateState('name')"
        :placeholder="$t('teaching.instructionalMethod.momentNamePlaceholder')"
        aria-describedby="input-instructional-moment-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-instructional-moment-name-live-feedback">
        {{ $t("reusable.common.minLength", { min: 3 }) }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldOrder')}:`"
      label-for="input-instructional-moment-order"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-instructional-moment-order"
        name="input-instructional-moment-order"
        type="number"
        min="1"
        v-model="$v.instructional_moment.order.$model"
        :state="validateState('order')"
        aria-describedby="input-instructional-moment-order-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback
        id="input-instructional-moment-order-live-feedback"
      >
        {{ $t("reusable.common.numericAndGreaterThanZero") }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldColor')}:`"
      label-for="input-instructional-moment-color"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-instructional-moment-color"
        name="input-instructional-moment-color"
        type="color"
        v-model="instructional_moment.color"
        size="sm"
        class="input-color"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      :label="`${$t('teaching.instructionalMethod.fieldDescription')}:`"
      label-for="input-instructional-moment-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-textarea
        id="input-instructional-moment-description"
        name="input-instructional-moment-description"
        v-model="instructional_moment.description"
        size="sm"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>

    <div class="row mt-3">
      <div class="col" style="text-align: right">
        <b-button class="m-0 mr-1" size="sm" :disabled="saving" @click="save">
          {{ $t("reusable.common.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  numeric,
  minValue,
} from "vuelidate/lib/validators";
import * as names from "@/store/names";

const DEFAULT_COLOR = "#6c757d";

export default {
  name: "InstructionalMomentForm",
  mixins: [validationMixin],
  props: {
    // null => creación.
    InstructionalMoment: {
      type: Object,
      default: null,
    },
    instructional_method_id: {
      type: Number,
      required: true,
    },
    // Orden sugerido al crear: se ubica al final de los existentes.
    next_order: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      instructional_moment: {
        name: this.InstructionalMoment ? this.InstructionalMoment.name : "",
        description: this.InstructionalMoment
          ? this.InstructionalMoment.description || ""
          : "",
        order: this.InstructionalMoment
          ? this.InstructionalMoment.order
          : this.next_order,
        color:
          this.InstructionalMoment && this.InstructionalMoment.color
            ? this.InstructionalMoment.color
            : DEFAULT_COLOR,
      },
      saving: false,
    };
  },
  validations: {
    instructional_moment: {
      name: {
        required,
        minLength: minLength(3),
      },
      order: {
        required,
        numeric,
        minValue: minValue(1),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.instructional_moment[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.instructional_moment.$touch();
      if (this.$v.instructional_moment.$anyError) return;
      this.saving = true;
      const payload = {
        name: this.instructional_moment.name.trim(),
        description: this.instructional_moment.description,
        order: Number(this.instructional_moment.order),
        color: this.instructional_moment.color,
      };
      const request = this.InstructionalMoment
        ? this.$store.dispatch(names.PATCH_INSTRUCTIONAL_MOMENT, {
            instructional_moment_id: this.InstructionalMoment.id,
            item: payload,
          })
        : this.$store.dispatch(names.POST_INSTRUCTIONAL_MOMENT, {
            ...payload,
            method: this.instructional_method_id,
          });

      request
        .then((response) => {
          this.saving = false;
          toast(
            String(
              this.$t("teaching.instructionalMethod.momentEntity") +
                " " +
                (this.InstructionalMoment
                  ? this.$t("reusable.common.updated")
                  : this.$t("reusable.common.created"))
            )
          );
          this.$emit("saved", response);
        })
        .catch(() => {
          this.saving = false;
          toast(this.$t("teaching.instructionalMethod.saveError"));
        });
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1%;
}
.input-color {
  cursor: pointer;
  max-width: 6rem;
  padding: 0.1rem;
}
</style>
